import React from 'react'
import { DEFAULT_LINE_WIDTH, SELECTED_LINE_WIDTH } from '../constants'

export default function CommentLineStraight({
  annotationId,
  height,
  isSelected,
  rect,
  viewportWidth,
  widthExtension,
}) {
  const [[left], [right, top]] = rect
  const width = right - left
  const lineLength = viewportWidth - left - width + widthExtension
  const d = `M ${lineLength}, ${DEFAULT_LINE_WIDTH - 1} C ${
    lineLength - lineLength * 0.5
  }, ${DEFAULT_LINE_WIDTH - 1}, ${lineLength * 0.5}, 1, 0, 1`

  return (
    <div className="CommentLine-container" id={`CommentLine-container-${annotationId}`}>
      <svg
        className="CommentLine"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${lineLength} ${DEFAULT_LINE_WIDTH}`}
        strokeWidth={isSelected ? SELECTED_LINE_WIDTH : DEFAULT_LINE_WIDTH}
        style={{
          left: `${left + width + 6}px`,
          top: `${top + 6}px`,
          width: `${lineLength}px`,
          height: `${
            isSelected
              ? Math.max(height, SELECTED_LINE_WIDTH)
              : Math.max(height, DEFAULT_LINE_WIDTH + 1)
          }px`,
        }}
      >
        <path d={d} stroke={'#aaaaaa'} strokeDasharray="5, 5" fill="none" />
      </svg>
    </div>
  )
}
